import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, IconButton, Typography } from "@mui/material";

const CustomDrawerHeader = ({
  handleClose,
  title,
  subtitle,
  otherText,
  fontSize,
}) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          bgcolor: (theme) => theme.palette.bgWhite.main,
          borderBottom: "1px solid #0000001A"
        }}
        elevation={0}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          minHeight="45px"
          p={"30px"}
        >
          <Box display={"flex"} flexWrap={"wrap"} alignItems='center' width="100%" gap={2}>
            <Typography
              variant="h6"
              color={(theme) => theme.palette.bgBlack.main}
              fontWeight="bold"
              fontSize={fontSize ? fontSize : "24px"}
              width={"80%"}
              fontFamily={"Satoshi-Bold"}
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                display="block"
                color={(theme) => theme.palette.bgBlack.main}
                paddingTop={0.5}
                fontSize={16}
                fontFamily={"Satoshi-Medium"}
              >
                {subtitle && subtitle}
              </Typography>
            )}
            {otherText && otherText}
          </Box>
          <IconButton
            color="default"
            size="medium"
            onClick={handleClose}
            sx={{
              bgcolor: "#F5F9FB",
              color: (theme) => theme.palette.bgBlack.main
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </AppBar>
    </Box>
  );
};

export default CustomDrawerHeader;
